import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 15C7 10.5817 10.5817 7 15 7C19.4183 7 23 10.5817 23 15C23 19.4183 19.4183 23 15 23C10.5817 23 7 19.4183 7 15ZM15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25C17.4003 25 19.603 24.1543 21.3266 22.7447L25.7898 27.2079C26.1803 27.5984 26.8135 27.5984 27.204 27.2079C27.5945 26.8174 27.5945 26.1842 27.204 25.7937L22.7412 21.3309C24.1529 19.6067 25 17.4023 25 15C25 9.47715 20.5228 5 15 5Z",
		fill: "inherit"
	})
});
export default SvgIcSearch;
